import SimpleCTA from '@/components/elements/SimpleCTA';
import StoreLinkAlt from '@/components/elements/StoreLink';
import { Button, Divider, Flex } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';

const DownloadCTA = () => {
  const { t } = useTranslation(`about`);

  return (
    <Flex
      className="boxed-container"
      direction={[`column`, null, null, `row`]}
      justify="space-between"
      align="center"
    >
      <SimpleCTA
        title={t(`call_to_action.download.header`)}
        description={t(`call_to_action.download.description`)}
      >
        <StoreLinkAlt
          href="https://apps.apple.com/tr/app/voltran-app/id1567581311"
          type="ios"
        />
        <StoreLinkAlt
          href="https://play.google.com/store/apps/details?id=com.voltran.app.voltran"
          type="android"
        />
      </SimpleCTA>
      <Divider
        display={[`none`, null, null, `block`]}
        h={96}
        mx={20}
        orientation="vertical"
      />
      <Divider
        display={[`block`, null, null, `none`]}
        my={16}
        orientation="horizontal"
      />
      <SimpleCTA
        title={t(`call_to_action.contact.header`)}
        description={t(`call_to_action.contact.description`)}
      >
        <Button variant="solid-brand-cta">
          {t(`call_to_action.contact.action_button`)}
        </Button>
      </SimpleCTA>
    </Flex>
  );
};

export default DownloadCTA;
